import { render, staticRenderFns } from "./SaleSettingsComponent.vue?vue&type=template&id=380e1613&"
import script from "./SaleSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./SaleSettingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports